var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({staticClass:"svg-icon",class:_vm.iconName,attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":("#icon-" + _vm.iconName)}})])}
var staticRenderFns = []

export { render, staticRenderFns }